import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const FormBottomElementWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const ButtonsDecorator = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: center;

        &:after,
        &:before {
            background: ${palette.text.primary};
            content: '';
            width: 8px;
            height: 1px;
        }
    `,
);
